import { lazy } from 'react';
import Route from './routing/Router';

import { leftBarSettingsItems } from './views/layout/layout-components/LeftBarSettingsItems';
import { leftBarFinanceItems } from './views/layout/layout-components/LeftBarFinanceItems';

// Authentication
const CompleteRegistration = lazy(() => import('./views/pages/Auth/CompleteRegistration'));
const LoginEmailOnly = lazy(() => import('./views/pages/Auth/LoginEmailOnly'));
const TwoFA = lazy(() => import('./views/pages/Auth/TwoFA'));
const Login = lazy(() => import('./views/pages/Auth/Login'));
const Logout = lazy(() => import('./views/pages/Auth/Logout'));
const Register = lazy(() => import('./views/pages/Auth/Register'));
const ForgotPassword = lazy(() => import('./views/pages/Auth/ForgotPassword'));
const ResetPassword = lazy(() => import('./views/pages/Auth/ResetPassword'));
const BlockedAccount = lazy(() => import('./views/pages/Auth/BlockedAccount'));
const VerifyEmail = lazy(() => import('./views/pages/Auth/VerifyEmail'));

/* ------------------ Dashboard ---------------- */
const DashboardHome = lazy(() => import('./views/pages/Dashboard/Home'));
const DashboardSettings = lazy(() => import('./views/pages/Dashboard/Settings'));
const DashboardUserSettings = lazy(() => import('./views/pages/Dashboard/UserSettings'));
const DashboardFinance = lazy(() => import('./views/pages/Dashboard/Finance'));

//Languages
const DashboardLanguages = lazy(() => import('./views/pages/Dashboard/Language/AllLanguages'));
const DashboardAddLanguage = lazy(() => import('./views/pages/Dashboard/Language/AddLanguage'));
const DashboardEditLanguage = lazy(() => import('./views/pages/Dashboard/Language/EditLanguage'));

//Departments
const DashboardDepartments = lazy(() => import('./views/pages/Dashboard/Department/AllDepartments'));
const DashboardAddDepartment = lazy(() => import('./views/pages/Dashboard/Department/AddDepartment'));
const DashboardEditDepartment = lazy(() => import('./views/pages/Dashboard/Department/EditDepartment'));
const DashboardDepartment = lazy(() => import('./views/pages/Dashboard/Department/Department'));

//Roles
const DashboardRoles = lazy(() => import('./views/pages/Dashboard/Role/AllRoles'));
const DashboardAddRole = lazy(() => import('./views/pages/Dashboard/Role/AddRole'));
const DashboardEditRole = lazy(() => import('./views/pages/Dashboard/Role/EditRole'));
const DashboardRole = lazy(() => import('./views/pages/Dashboard/Role/Role'));
const DashboardAllPermissions = lazy(
  () => import('./views/pages/Dashboard/Role/Permissions/RolePermissions')
);
const DashboardRoleAllFileTypes = lazy(() => import('./views/pages/Dashboard/Role/FileTypes/RoleFileTypes'));
const DashboardRoleAllStatuses = lazy(() => import('./views/pages/Dashboard/Role/Statuses/RoleStatuses'));

//Users
const DashboardUsers = lazy(() => import('./views/pages/Dashboard/User/AllUsers'));
const DashboardAddUser = lazy(() => import('./views/pages/Dashboard/User/AddUser'));
const DashboardEditUser = lazy(() => import('./views/pages/Dashboard/User/EditUser'));
const DashboardUser = lazy(() => import('./views/pages/Dashboard/User/User'));
const DashboardUserFilesArchive = lazy(() => import('./views/pages/Dashboard/User/FilesArchive'));

//Patients
const DashboardPatients = lazy(() => import('./views/pages/Dashboard/Patient/AllPatients'));
const DashboardAddPatient = lazy(() => import('./views/pages/Dashboard/Patient/AddPatient'));
const DashboardEditPatient = lazy(() => import('./views/pages/Dashboard/Patient/EditPatient'));
const DashboardPatient = lazy(() => import('./views/pages/Dashboard/Patient/Patient'));

//Driver Page
const DashboardTodaysSchedule = lazy(() => import('./views/pages/Dashboard/Driver/AllTodaysSchedules'));
const DashboardTodaysScheduleDriverLeg = lazy(
  () => import('./views/pages/Dashboard/Driver/TodaysSchedulesDriverLeg')
);
const DashboardTodaysScheduleDriverEventLeg = lazy(
  () => import('./views/pages/Dashboard/Driver/DriverEvent/TodaysSchedulesDriverEventLeg')
);
const DashboardTodaysSchedulePartnerPickup = lazy(
  () => import('./views/pages/Dashboard/Driver/PartnerPickup/TodaysSchedulesPartnerPickup')
);
const DashboardTodaysScheduleSignature = lazy(
  () => import('./views/pages/Dashboard/Driver/TodaysSchedulesSignature')
);
const DashboardTodaysScheduleFinishedSignature = lazy(
  () => import('./views/pages/Dashboard/Driver/TodaysSchedulesFinishedSignature')
);
const DashboardUpcomingSchedule = lazy(() => import('./views/pages/Dashboard/Driver/AllUpcomingSchedule'));
const DashboardTimeCard = lazy(() => import('./views/pages/Dashboard/Driver/AllTimeCard'));
const DashboardHistory = lazy(() => import('./views/pages/Dashboard/Driver/AllHistory'));
const DashboardPayStatements = lazy(
  () => import('./views/pages/Dashboard/Driver/PayStatements/AllPayStatements')
);
const DashboardPayStatement = lazy(() => import('./views/pages/Dashboard/Driver/PayStatements/PayStatement'));
const DashboardPayStatementAddSignature = lazy(
  () => import('./views/pages/Dashboard/Driver/PayStatements/AddSignature')
);
const DashboardTickets = lazy(() => import('./views/pages/Dashboard/Driver/Tickets'));

//Trips
// import DashboardTrips from "./views/pages/Dashboard/Trip/AllTrips";
const DashboardAddTrip = lazy(() => import('./views/pages/Dashboard/Trip/AddTrip'));
// import DashboardEditTrip from "./views/pages/Dashboard/Trip/EditTrip";

//Destinations
const DashboardDestinations = lazy(() => import('./views/pages/Dashboard/Destination/AllDestinations'));
const DashboardAddDestination = lazy(() => import('./views/pages/Dashboard/Destination/AddDestination'));
const DashboardEditDestination = lazy(() => import('./views/pages/Dashboard/Destination/EditDestination'));

//Dispatchers
const DashboardDispatchers = lazy(() => import('./views/pages/Dashboard/Dispatcher/AllDispatchers'));
const DashboardRightDrawer = lazy(() => import('./views/pages/Dashboard/Dispatcher/RightDrawer'));

//DashboardDispatchersDnd
const DashboardDispatchersDnd = lazy(() => import('./views/pages/Dashboard/DispatcherDnd/AllDispatchersDnd'));
const DashboardRightDrawerDnd = lazy(() => import('./views/pages/Dashboard/DispatcherDnd/RightDrawer'));
const DashboardRightDrawerDndDriverEvent = lazy(
  () => import('./views/pages/Dashboard/DispatcherDnd/DriverEvents/RightDrawer')
);

//Reports
const DashboardReports = lazy(() => import('./views/pages/Dashboard/Reports/AllReports'));

//Payroll
// const DashboardPayroll = lazy(() => import ( './views/pages/Dashboard/Payroll/AllPayroll'));
// const DashboardEditPayroll = lazy(() => import ( './views/pages/Dashboard/Payroll/EditPayroll'));

//Finance
const DashboardAccountPayable = lazy(
  () => import('./views/pages/Dashboard/Finance/AccountPayable/AccountPayable')
);

//Map
const DashboardMap = lazy(() => import('./views/pages/Dashboard/Map/MapPage'));

//Billing
const DashboardBilling = lazy(() => import('./views/pages/Dashboard/Billing/BillingPage'));
const DashboardBillingBatchList = lazy(() => import('./views/pages/Dashboard/Billing/BillingBatchList'));
const DashboardBillingBatchLegList = lazy(
  () => import('./views/pages/Dashboard/Billing/BatchLegs/BillingBatchLegList')
);

const DashboardHelp = lazy(() => import('./views/pages/Dashboard/Help/HelpPage'));
const DashboardSupport = lazy(() => import('./views/pages/Dashboard/Support/SupportPage'));
const DashboardCompany = lazy(() => import('./views/pages/Dashboard/Company/CompanyPage'));

//Status
const DashboardStatus = lazy(() => import('./views/pages/Dashboard/Status/AllStatus'));
const DashboardAddStatus = lazy(() => import('./views/pages/Dashboard/Status/AddStatus'));
const DashboardEditStatus = lazy(() => import('./views/pages/Dashboard/Status/EditStatus'));

//Vehicles
const DashboardVehicles = lazy(() => import('./views/pages/Dashboard/Vehicle/AllVehicles'));
const DashboardAddVehicle = lazy(() => import('./views/pages/Dashboard/Vehicle/AddVehicle'));
const DashboardEditVehicle = lazy(() => import('./views/pages/Dashboard/Vehicle/EditVehicle'));
const DashboardVehicle = lazy(() => import('./views/pages/Dashboard/Vehicle/Vehicle'));
const DashboardVehicleFilesArchive = lazy(() => import('./views/pages/Dashboard/Vehicle/FilesArchive'));

//Mobile Providers
const DashboardMobileProviders = lazy(
  () => import('./views/pages/Dashboard/MobileProvider/AllMobileProviders')
);
const DashboardAddMobileProvider = lazy(
  () => import('./views/pages/Dashboard/MobileProvider/AddMobileProvider')
);
const DashboardEditMobileProvider = lazy(
  () => import('./views/pages/Dashboard/MobileProvider/EditMobileProvider')
);
const DashboardMobileProvider = lazy(() => import('./views/pages/Dashboard/MobileProvider/MobileProvider'));

//File Types
const DashboardFileTypes = lazy(() => import('./views/pages/Dashboard/FileType/AllFileTypes'));
const DashboardAddFileType = lazy(() => import('./views/pages/Dashboard/FileType/AddFileType'));
const DashboardEditFileType = lazy(() => import('./views/pages/Dashboard/FileType/EditFileType'));

//Forms
const DashboardForms = lazy(() => import('./views/pages/Dashboard/Form/AllForms'));
const DashboardFormSettings = lazy(() => import('./views/pages/Dashboard/Form/FormSettings'));
const DashboardFormFilesArchive = lazy(() => import('./views/pages/Dashboard/Form/FormFilesArchive'));

//Auto Type
const DashboardAutotypes = lazy(() => import('./views/pages/Dashboard/AutoType/AllAutoTypes'));
const DashboardAddAutotype = lazy(() => import('./views/pages/Dashboard/AutoType/AddAutoType'));
const DashboardEditAutotype = lazy(() => import('./views/pages/Dashboard/AutoType/EditAutoType'));
const DashboardAutotype = lazy(() => import('./views/pages/Dashboard/AutoType/AutoType'));
const DashboardAutoTypeAllFileTypes = lazy(
  () => import('./views/pages/Dashboard/AutoType/FileTypes/AutoTypeFileTypes')
);

//Patient Cancel Reasons
const DashboardCancelReasons = lazy(
  () => import('./views/pages/Dashboard/PatientCancelReason/AllCancelReasons')
);
const DashboardAddCancelReason = lazy(
  () => import('./views/pages/Dashboard/PatientCancelReason/AddCancelReason')
);
const DashboardEditCancelReason = lazy(
  () => import('./views/pages/Dashboard/PatientCancelReason/EditCancelReason')
);

//Driver Decline Reasons
const DashboardDeclineReasons = lazy(
  () => import('./views/pages/Dashboard/DriverDeclineReason/AllDeclineReasons')
);
const DashboardAddDeclineReason = lazy(
  () => import('./views/pages/Dashboard/DriverDeclineReason/AddDeclineReason')
);
const DashboardEditDeclineReason = lazy(
  () => import('./views/pages/Dashboard/DriverDeclineReason/EditDeclineReason')
);

//Insurance
const DashboardInsurances = lazy(() => import('./views/pages/Dashboard/Insurance/AllInsurances'));
const DashboardAddInsurance = lazy(() => import('./views/pages/Dashboard/Insurance/AddInsurance'));
const DashboardEditInsurance = lazy(() => import('./views/pages/Dashboard/Insurance/EditInsurance'));
const DashboardInsurance = lazy(() => import('./views/pages/Dashboard/Insurance/Insurance'));
const DashboardInsuranceServices = lazy(
  () => import('./views/pages/Dashboard/Insurance/Services/InsuranceServices')
);

//Zip Codes
const DashboardZipCodeGroups = lazy(() => import('./views/pages/Dashboard/ZipCodes/AllZipCodeGroups'));

//Routes
const DashboardRoutes = lazy(() => import('./views/pages/Dashboard/Routes/AllRoutes'));
const DashboardEditRoutes = lazy(() => import('./views/pages/Dashboard/Routes/EditRoute'));

//Routes
const DashboardAllDailySharedRides = lazy(
  () => import('./views/pages/Dashboard/DailySharedRides/AllDailySharedRides')
);
const DashboardEditDailySharedRide = lazy(
  () => import('./views/pages/Dashboard/DailySharedRides/EditDailySharedRide')
);

//StandingOrders
const DashboardEditStandingOrders = lazy(() => import('./views/pages/Dashboard/Patient/EditStandingOrder'));

// Driver Events
const DashboardDriverEvents = lazy(() => import('./views/pages/Dashboard/DriverEvents/AllEvents'));
const DashboardAddDriverEvent = lazy(() => import('./views/pages/Dashboard/DriverEvents/AddEvent'));
const DashboardEditDriverEvent = lazy(() => import('./views/pages/Dashboard/DriverEvents/EditEvent'));

// Vehicle Equipment
const DashboardVehicleEquipment = lazy(
  () => import('./views/pages/Dashboard/VehicleEquipment/AllVehicleEquipment')
);
const DashboardAddVehicleEquipment = lazy(
  () => import('./views/pages/Dashboard/VehicleEquipment/AddVehicleEquipment')
);
const DashboardEditVehicleEquipment = lazy(
  () => import('./views/pages/Dashboard/VehicleEquipment/EditVehicleEquipment')
);

// Vehicle Capacity Type
const DashboardVehicleCapacityType = lazy(
  () => import('./views/pages/Dashboard/VehicleCapacityType/AllVehicleCapacityType')
);
const DashboardAddVehicleCapacityType = lazy(
  () => import('./views/pages/Dashboard/VehicleCapacityType/AddVehicleCapacityType')
);
const DashboardEditVehicleCapacityType = lazy(
  () => import('./views/pages/Dashboard/VehicleCapacityType/EditVehicleCapacityType')
);

// Vehicle Capacity
const DashboardVehicleCapacity = lazy(
  () => import('./views/pages/Dashboard/VehicleCapacity/AllVehicleCapacity')
);
const DashboardAddVehicleCapacity = lazy(
  () => import('./views/pages/Dashboard/VehicleCapacity/AddVehicleCapacity')
);
const DashboardEditVehicleCapacity = lazy(
  () => import('./views/pages/Dashboard/VehicleCapacity/EditVehicleCapacity')
);

// API Token
const DashboardApiTokens = lazy(() => import('./views/pages/Dashboard/ApiTokens/AllApiTokens'));
//Driver Inspections
const DriverInspections = lazy(() => import('./views/pages/Driver/Inspections/AllInspections'));
/* ------------------ End Dashboard ---------------- */

const NotFound = lazy(() => import('./views/pages/NotFound'));

Route.add('login_with_email', {
  path: '/login-with-email',
  component: LoginEmailOnly,
});

Route.add('2_fa', {
  path: '/2-fa',
  component: TwoFA,
});

/* --------------------  account  --------------------- */
Route.group('/account', () => {
  Route.add('account_login', {
    path: '/login',
    component: Login,
  });

  Route.add('complete_registration', {
    path: '/complete-registration/:token',
    component: CompleteRegistration,
  });

  Route.add('account_logout', {
    path: '/logout',
    component: Logout,
  });

  Route.add('account_register', {
    path: '/register',
    component: Register,
  });

  Route.add('account_forgot', {
    path: '/forgot-password',
    component: ForgotPassword,
  });

  Route.add('account_reset', {
    path: '/reset-password/:token',
    component: ResetPassword,
  });

  Route.add('blocked_account', {
    path: '/blocked-account',
    component: BlockedAccount,
  });

  Route.add('verify_email', {
    path: '/verify-email/:token',
    component: VerifyEmail,
  });
});

/* --------------------  dashboard  --------------------- */
Route.group('/dashboard', () => {
  Route.redirectRoute('/', 'dashboard_home');

  Route.add('dashboard_home', {
    path: '/home',
    component: DashboardHome,
    auth: true,
  });

  Route.add('dashboard_settings', {
    path: '/settings',
    component: DashboardSettings,
    auth: true,
    permissionNamesGroup: leftBarSettingsItems.map((item) => item.permissionName),
  });

  Route.add('user_settings', {
    path: '/user_settings',
    component: DashboardUserSettings,
    auth: true,
  });

  Route.group('/languages', () => {
    Route.add('dashboard_language_all', {
      path: '/all',
      component: DashboardLanguages,
      auth: true,
      permissionName: 'language',
    });
    Route.add('dashboard_language_add', {
      path: '/add-new',
      component: DashboardAddLanguage,
      auth: true,
      permissionName: 'language',
      requiredManageAccess: true,
    });

    Route.group('/languages', () => {
      Route.add('dashboard_language_all', {
        path: '/all',
        component: DashboardLanguages,
        auth: true,
        permissionName: 'language',
      });
      Route.add('dashboard_language_add', {
        path: '/add-new',
        component: DashboardAddLanguage,
        auth: true,
        permissionName: 'language',
        requiredManageAccess: true,
      });
    });

    Route.group('/:languageId', () => {
      Route.add('dashboard_language_edit', {
        path: '/edit',
        component: DashboardEditLanguage,
        auth: true,
        permissionName: 'language',
        requiredManageAccess: true,
      });
    });
  });

  Route.add('dashboard_finance', {
    path: '/finance',
    component: DashboardFinance,
    auth: true,
    permissionNamesGroup: leftBarFinanceItems.map((item) => item.permissionName),
  });

  Route.group('/finance', () => {
    Route.add('dashboard_account_payable', {
      path: '/account-payable',
      component: DashboardAccountPayable,
      auth: true,
    });
  });

  Route.group('/departments', () => {
    Route.add('dashboard_department_all', {
      path: '/all',
      component: DashboardDepartments,
      auth: true,
      permissionName: 'department',
    });
    Route.add('dashboard_department_add', {
      path: '/add-new',
      component: DashboardAddDepartment,
      auth: true,
      permissionName: 'department',
      requiredManageAccess: true,
    });
    Route.group('/:departmentId', () => {
      Route.add('dashboard_department_edit', {
        path: '/edit',
        component: DashboardEditDepartment,
        auth: true,
        permissionName: 'department',
        requiredManageAccess: true,
      });
      Route.add('dashboard_department', {
        path: '/department',
        component: DashboardDepartment,
        auth: true,
        permissionName: 'department',
      });
    });
  });

  Route.group('/roles', () => {
    Route.add('dashboard_role_all', {
      path: '/all',
      component: DashboardRoles,
      auth: true,
      permissionName: 'role',
    });
    Route.add('dashboard_role_add', {
      path: '/add-new',
      component: DashboardAddRole,
      auth: true,
      permissionName: 'role',
      requiredManageAccess: true,
    });
    Route.group('/:roleId', () => {
      Route.add('dashboard_role_edit', {
        path: '/edit',
        component: DashboardEditRole,
        auth: true,
        permissionName: 'role',
        requiredManageAccess: true,
      });
      Route.add('dashboard_role', {
        path: '/role',
        component: DashboardRole,
        auth: true,
        permissionName: 'role',
      });
      Route.group('/permissions', () => {
        Route.add('dashboard_role_permissions', {
          path: '/all',
          component: DashboardAllPermissions,
          auth: true,
          permissionName: 'role',
          requiredManageAccess: true,
        });
      });
      Route.group('/file-types', () => {
        Route.add('dashboard_role_file_types', {
          path: '/all',
          component: DashboardRoleAllFileTypes,
          auth: true,
          permissionName: 'role',
          requiredManageAccess: true,
        });
      });
      Route.group('/role-statuses', () => {
        Route.add('dashboard_role_statuses', {
          path: '/all',
          component: DashboardRoleAllStatuses,
          auth: true,
          permissionName: 'role',
          requiredManageAccess: true,
        });
      });
    });
  });

  Route.group('/users', () => {
    Route.add('dashboard_user_all', {
      path: '/all',
      component: DashboardUsers,
      auth: true,
      permissionName: 'user',
    });
    Route.add('dashboard_user_add', {
      path: '/add-new',
      component: DashboardAddUser,
      auth: true,
      permissionName: 'user',
      requiredManageAccess: true,
    });
    Route.group('/:userId', () => {
      Route.add('dashboard_user_edit', {
        path: '/edit',
        component: DashboardEditUser,
        auth: true,
        permissionName: 'user',
        requiredManageAccess: true,
      });
      Route.add('dashboard_user', {
        path: '/user',
        component: DashboardUser,
        auth: true,
        permissionName: 'user',
      });
      Route.add('dashboard_user_files_archive', {
        path: '/:roleId/files-archive',
        component: DashboardUserFilesArchive,
        auth: true,
        permissionName: 'user',
      });
    });
  });

  Route.group('/patients', () => {
    Route.add('dashboard_patient_all', {
      path: '/all',
      component: DashboardPatients,
      auth: true,
      permissionName: 'patient',
    });
    Route.add('dashboard_patient_add', {
      path: '/add-new',
      component: DashboardAddPatient,
      auth: true,
      permissionName: 'patient',
      requiredManageAccess: true,
    });
    Route.group('/:patientId', () => {
      Route.add('dashboard_patient_edit', {
        path: '/edit',
        component: DashboardEditPatient,
        auth: true,
        permissionName: 'patient',
        requiredManageAccess: true,
      });
      Route.add('dashboard_patient', {
        path: '/patient',
        component: DashboardPatient,
        auth: true,
        permissionName: 'patient',
      });
    });
  });

  Route.group('/todays-schedule', () => {
    Route.add('dashboard_todays_schedule_all', {
      path: '/all',
      component: DashboardTodaysSchedule,
      auth: true,
      permissionName: 'todays-schedule',
    });
    Route.group('/:legId', () => {
      Route.add('dashboard_todays_schedule_leg', {
        path: '/driver-leg',
        component: DashboardTodaysScheduleDriverLeg,
        auth: true,
        permissionName: 'todays-schedule',
        requiredManageAccess: true,
      });
      Route.add('dashboard_todays_schedule_signature', {
        path: '/signature',
        component: DashboardTodaysScheduleSignature,
        auth: true,
        permissionName: 'todays-schedule',
        requiredManageAccess: true,
      });
    });
    Route.group('/:driverEventLegId', () => {
      Route.add('dashboard_todays_schedule_driver_event_leg', {
        path: '/driver-event-leg',
        component: DashboardTodaysScheduleDriverEventLeg,
        auth: true,
        permissionName: 'todays-schedule',
        requiredManageAccess: true,
      });
    });
    Route.group('/:partnerPickupId', () => {
      Route.add('dashboard_todays_schedule_partner_pickup', {
        path: '/partner-pickup',
        component: DashboardTodaysSchedulePartnerPickup,
        auth: true,
        permissionName: 'todays-schedule',
        requiredManageAccess: true,
      });
    });
    Route.group('/:date', () => {
      Route.add('dashboard_todays_schedule_finished_signature', {
        path: '/finished-signature',
        component: DashboardTodaysScheduleFinishedSignature,
        auth: true,
        permissionName: 'todays-schedule',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/pay-statments', () => {
    Route.add('dashboard_pay_statement_all', {
      path: '/all',
      component: DashboardPayStatements,
      auth: true,
      permissionName: 'pay-statements',
    });

    Route.group('/:batchId', () => {
      Route.add('dashboard_pay_statement', {
        path: '',
        component: DashboardPayStatement,
        auth: true,
        permissionName: 'pay-statements',
      });

      Route.add('dashboard_pay_statement_add_signature', {
        path: '/add-signature',
        component: DashboardPayStatementAddSignature,
        auth: true,
        permissionName: 'pay-statements',
      });
    });
  });

  Route.group('/tickets', () => {
    Route.add('dashboard_tickets_all', {
      path: '/all',
      component: DashboardTickets,
      auth: true,
      permissionName: 'ticket',
    });
  });

  Route.group('/api-tokens', () => {
    Route.add('dashboard_api_tokens_all', {
      path: '/all',
      component: DashboardApiTokens,
      auth: true,
      permissionName: 'api-tokens',
    });
  });

  Route.group('/upcoming-schedule', () => {
    Route.add('dashboard_upcoming_schedule_all', {
      path: '/all',
      component: DashboardUpcomingSchedule,
      auth: true,
      permissionName: 'upcoming-schedule',
    });
  });

  Route.group('/time-card', () => {
    Route.add('dashboard_time_card_all', {
      path: '/all',
      component: DashboardTimeCard,
      auth: true,
      permissionName: 'time-card',
    });
  });

  Route.group('/history', () => {
    Route.add('dashboard_history_all', {
      path: '/all',
      component: DashboardHistory,
      auth: true,
      permissionName: 'history',
    });
  });

  Route.group('/api-tokens', () => {
    Route.add('dashboard_api_tokens_all', {
      path: '/all',
      component: DashboardApiTokens,
      auth: true,
      permissionName: 'api-tokens',
    });
  });

  Route.group('/events', () => {
    Route.add('dashboard_driver_events_all', {
      path: '/all',
      component: DashboardDriverEvents,
      auth: true,
      permissionName: 'driver-events',
    });

    Route.add('dashboard_driver_event_add', {
      path: '/add-new',
      component: DashboardAddDriverEvent,
      auth: true,
      permissionName: 'driver-events',
    });

    Route.group('/:eventId', () => {
      Route.add('dashboard_driver_event_edit', {
        path: '/edit',
        component: DashboardEditDriverEvent,
        auth: true,
        permissionName: 'driver-events',
      });
    });
  });

  Route.group('/vehicle-equipment', () => {
    Route.add('dashboard_vehicle_equipment_all', {
      path: '/all',
      component: DashboardVehicleEquipment,
      auth: true,
      permissionName: 'vehicle-equipment',
    });

    Route.add('dashboard_vehicle_equipment_add', {
      path: '/add-new',
      component: DashboardAddVehicleEquipment,
      auth: true,
      permissionName: 'vehicle-equipment',
    });

    Route.group('/:vehicleEquipmentId', () => {
      Route.add('dashboard_vehicle_equipment_edit', {
        path: '/edit',
        component: DashboardEditVehicleEquipment,
        auth: true,
        permissionName: 'vehicle-equipment',
      });
    });
  });

  Route.group('/vehicle-capacity-type', () => {
    Route.add('dashboard_vehicle_capacity_type_all', {
      path: '/all',
      component: DashboardVehicleCapacityType,
      auth: true,
      permissionName: 'vehicle-capacity-type',
    });

    Route.add('dashboard_vehicle_capacity_type_add', {
      path: '/add-new',
      component: DashboardAddVehicleCapacityType,
      auth: true,
      permissionName: 'vehicle-capacity-type',
    });

    Route.group('/:vehicleCapacityTypeId', () => {
      Route.add('dashboard_vehicle_capacity_type_edit', {
        path: '/edit',
        component: DashboardEditVehicleCapacityType,
        auth: true,
        permissionName: 'vehicle-capacity-type',
      });
    });
  });

  Route.group('/vehicle-capacity', () => {
    Route.add('dashboard_vehicle_capacity_all', {
      path: '/all',
      component: DashboardVehicleCapacity,
      auth: true,
      permissionName: 'vehicle-capacity',
    });

    Route.add('dashboard_vehicle_capacity_add', {
      path: '/add-new',
      component: DashboardAddVehicleCapacity,
      auth: true,
      permissionName: 'vehicle-capacity',
    });

    Route.group('/:vehicleCapacityId', () => {
      Route.add('dashboard_vehicle_capacity_edit', {
        path: '/edit',
        component: DashboardEditVehicleCapacity,
        auth: true,
        permissionName: 'vehicle-capacity',
      });
    });
  });

  Route.group('/trips', () => {
    Route.add('dashboard_trip_add', {
      path: '/add-new',
      component: DashboardAddTrip,
      auth: true,
      permissionName: 'trip',
      requiredManageAccess: true,
    });

    Route.add('dashboard_trip_add_patient_selected', {
      path: '/add-new/:patientId',
      component: DashboardAddTrip,
      auth: true,
      permissionName: 'trip',
      requiredManageAccess: true,
    });
  });

  Route.group('/destinations', () => {
    Route.add('dashboard_destination_all', {
      path: '/all',
      component: DashboardDestinations,
      auth: true,
      permissionName: 'destination',
    });
    Route.add('dashboard_destination_add', {
      path: '/add-new',
      component: DashboardAddDestination,
      auth: true,
      permissionName: 'destination',
      requiredManageAccess: true,
    });
    Route.group('/:destinationId', () => {
      Route.add('dashboard_destination_edit', {
        path: '/edit',
        component: DashboardEditDestination,
        auth: true,
        permissionName: 'destination',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/dispatchers', () => {
    Route.add('dashboard_dispatcher_all', {
      path: '/all',
      component: DashboardDispatchers,
      auth: true,
      permissionName: 'dispatcher',
    });
    Route.add('dashboard_dispatcher_one_leg', {
      path: '/one-leg/:id',
      component: DashboardRightDrawer,
      auth: true,
      permissionName: 'dispatcher',
    });
  });

  Route.group('/dispatchers_dnd', () => {
    Route.add('dashboard_dispatcher_all_dnd', {
      path: '/all',
      component: DashboardDispatchersDnd,
      auth: true,
      permissionName: 'dispatcher',
    });
    Route.add('dashboard_dispatcher_one_leg_dnd', {
      path: '/one-leg-dnd/:id',
      component: DashboardRightDrawerDnd,
      auth: true,
      permissionName: 'dispatcher',
    });
    Route.add('dashboard_dispatcher_one_driver-event_dnd', {
      path: '/one-driver-event-dnd/:id',
      component: DashboardRightDrawerDndDriverEvent,
      auth: true,
      permissionName: 'dispatcher',
    });
  });

  Route.group('/reports', () => {
    Route.add('dashboard_reports', {
      path: '/all',
      component: DashboardReports,
      auth: true,
      permissionName: 'reports',
    });
  });

  // Route.group('/payroll', () => {
  //   Route.add('dashboard_payroll', {
  //     path: '/all',
  //     component: DashboardPayroll,
  //     auth: true,
  //     permissionName: 'payroll',
  //   });
  //   Route.group('/:userId', () => {
  //     Route.add('dashboard_payroll_edit', {
  //       path: '/edit',
  //       component: DashboardEditPayroll,
  //       auth: true,
  //       permissionName: 'payroll',
  //       requiredManageAccess: true,
  //     });
  //   });
  // });

  Route.group('/status', () => {
    Route.add('dashboard_status_all', {
      path: '/all',
      component: DashboardStatus,
      auth: true,
      permissionName: 'status',
    });
    Route.add('dashboard_status_add', {
      path: '/add-new',
      component: DashboardAddStatus,
      auth: true,
      permissionName: 'status',
      requiredManageAccess: true,
    });
    Route.group('/:statusId', () => {
      Route.add('dashboard_status_edit', {
        path: '/edit',
        component: DashboardEditStatus,
        auth: true,
        permissionName: 'status',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/map', () => {
    Route.add('dashboard_map', {
      path: '',
      component: DashboardMap,
      auth: true,
      permissionName: 'map',
    });
  });

  Route.group('/billing', () => {
    Route.add('dashboard_billing', {
      path: '',
      component: DashboardBilling,
      auth: true,
      permissionName: 'billing',
    });
    Route.group('/:insuranceId', () => {
      Route.add('dashboard_billing_batch_list', {
        path: '/batch-list',
        component: DashboardBillingBatchList,
        auth: true,
        permissionName: 'billing',
      });
    });
    Route.group('/:batchId', () => {
      Route.add('dashboard_billing_batch_leg_list', {
        path: '/leg-list',
        component: DashboardBillingBatchLegList,
        auth: true,
        permissionName: 'billing',
      });
    });
  });

  Route.add('dashboard_help', {
    path: '/dashboard_help',
    component: DashboardHelp,
    auth: true,
  });

  Route.add('dashboard_support', {
    path: '/dashboard_support',
    component: DashboardSupport,
    auth: true,
  });

  Route.add('dashboard_company', {
    path: '/dashboard_company',
    component: DashboardCompany,
    auth: true,
  });

  Route.group('/vehicles', () => {
    Route.add('dashboard_vehicle_all', {
      path: '/all',
      component: DashboardVehicles,
      auth: true,
      permissionName: 'vehicle',
    });
    Route.add('dashboard_vehicle_add', {
      path: '/add-new',
      component: DashboardAddVehicle,
      auth: true,
      permissionName: 'vehicle',
      requiredManageAccess: true,
    });
    Route.group('/:vehicleId', () => {
      Route.add('dashboard_vehicle_edit', {
        path: '/edit',
        component: DashboardEditVehicle,
        auth: true,
        permissionName: 'vehicle',
        requiredManageAccess: true,
      });
      Route.add('dashboard_vehicle', {
        path: '/vehicle',
        component: DashboardVehicle,
        auth: true,
        permissionName: 'vehicle',
      });
      Route.add('dashboard_vehicle_files_archive', {
        path: '/files-archive',
        component: DashboardVehicleFilesArchive,
        auth: true,
        permissionName: 'vehicle',
      });
    });
  });

  Route.group('/mobileproviders', () => {
    Route.add('dashboard_mobileprovider_all', {
      path: '/all',
      component: DashboardMobileProviders,
      auth: true,
      permissionName: 'mobile-provider',
    });
    Route.add('dashboard_mobileprovider_add', {
      path: '/add-new',
      component: DashboardAddMobileProvider,
      auth: true,
      permissionName: 'mobile-provider',
      requiredManageAccess: true,
    });
    Route.group('/:mobileproviderId', () => {
      Route.add('dashboard_mobileprovider_edit', {
        path: '/edit',
        component: DashboardEditMobileProvider,
        auth: true,
        permissionName: 'mobile-provider',
        requiredManageAccess: true,
      });
      Route.add('dashboard_mobileprovider', {
        path: '/mobileprovider',
        component: DashboardMobileProvider,
        auth: true,
        permissionName: 'mobile-provider',
      });
    });
  });

  Route.group('/autotypes', () => {
    Route.add('dashboard_autotype_all', {
      path: '/all',
      component: DashboardAutotypes,
      auth: true,
      permissionName: 'auto-type',
    });
    Route.add('dashboard_autotype_add', {
      path: '/add-new',
      component: DashboardAddAutotype,
      auth: true,
      permissionName: 'auto-type',
      requiredManageAccess: true,
    });
    Route.group('/:autotypeId', () => {
      Route.add('dashboard_autotype_edit', {
        path: '/edit',
        component: DashboardEditAutotype,
        auth: true,
        permissionName: 'auto-type',
        requiredManageAccess: true,
      });
      Route.add('dashboard_autotype', {
        path: '/autotype',
        component: DashboardAutotype,
        auth: true,
        permissionName: 'auto-type',
      });
      Route.group('/file-types', () => {
        Route.add('dashboard_auto_type_file_types', {
          path: '/all',
          component: DashboardAutoTypeAllFileTypes,
          auth: true,
          permissionName: 'auto-type',
          requiredManageAccess: true,
        });
      });
    });
  });

  Route.group('/cancelreasons', () => {
    Route.add('dashboard_cancelreason_all', {
      path: '/all',
      component: DashboardCancelReasons,
      auth: true,
      permissionName: 'patient-cancel-reason',
    });
    Route.add('dashboard_cancelreason_add', {
      path: '/add-new',
      component: DashboardAddCancelReason,
      auth: true,
      permissionName: 'patient-cancel-reason',
      requiredManageAccess: true,
    });
    Route.group('/:cancelreasonId', () => {
      Route.add('dashboard_cancelreason_edit', {
        path: '/edit',
        component: DashboardEditCancelReason,
        auth: true,
        permissionName: 'patient-cancel-reason',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/declinereasons', () => {
    Route.add('dashboard_declinereason_all', {
      path: '/all',
      component: DashboardDeclineReasons,
      auth: true,
      permissionName: 'driver-decline-reason',
    });
    Route.add('dashboard_declinereason_add', {
      path: '/add-new',
      component: DashboardAddDeclineReason,
      auth: true,
      permissionName: 'driver-decline-reason',
      requiredManageAccess: true,
    });
    Route.group('/:declinereasonId', () => {
      Route.add('dashboard_declinereason_edit', {
        path: '/edit',
        component: DashboardEditDeclineReason,
        auth: true,
        permissionName: 'driver-decline-reason',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/zip-code-groups', () => {
    Route.add('dashboard_zip_code_groups_all', {
      path: '/all',
      component: DashboardZipCodeGroups,
      auth: true,
      permissionName: 'zip-code',
      requiredManageAccess: false,
    });
  });

  Route.group('/routes', () => {
    Route.add('dashboard_routes', {
      path: '/all',
      component: DashboardRoutes,
      auth: true,
      permissionName: 'routes',
    });
    Route.group('/:routeId', () => {
      Route.add('dashboard_routes_edit', {
        path: '/edit',
        component: DashboardEditRoutes,
        auth: true,
        permissionName: 'routes',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/daily-shared-rides', () => {
    Route.add('dashboard_daily_shared_rides', {
      path: '/all',
      component: DashboardAllDailySharedRides,
      auth: true,
      permissionName: 'daily-shared-rides',
    });
    Route.group('/:dailySharedRideId', () => {
      Route.add('dashboard_shared_rides_edit', {
        path: '/edit',
        component: DashboardEditDailySharedRide,
        auth: true,
        permissionName: 'daily-shared-rides',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/standing_orders', () => {
    Route.group('/:standingOrderId', () => {
      Route.add('dashboard_standing_orders_edit', {
        path: '/edit',
        component: DashboardEditStandingOrders,
        auth: true,
        permissionName: 'standing_orders',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/insurances', () => {
    Route.add('dashboard_insurance_all', {
      path: '/all',
      component: DashboardInsurances,
      auth: true,
      permissionName: 'insurance',
    });
    Route.add('dashboard_insurance_add', {
      path: '/add-new',
      component: DashboardAddInsurance,
      auth: true,
      permissionName: 'insurance',
      requiredManageAccess: true,
    });
    Route.group('/:insuranceId', () => {
      Route.add('dashboard_insurance_edit', {
        path: '/edit',
        component: DashboardEditInsurance,
        auth: true,
        permissionName: 'insurance',
        requiredManageAccess: true,
      });
      Route.add('dashboard_insurance', {
        path: '/insurance',
        component: DashboardInsurance,
        auth: true,
        permissionName: 'insurance',
      });
      Route.group('/services', () => {
        Route.add('dashboard_insurance_services', {
          path: '/all',
          component: DashboardInsuranceServices,
          auth: true,
          permissionName: 'insurance',
          requiredManageAccess: true,
        });
      });
    });
  });

  Route.group('/filetypes', () => {
    Route.add('dashboard_filetype_all', {
      path: '/all',
      component: DashboardFileTypes,
      auth: true,
      permissionName: 'file-type',
    });
    Route.add('dashboard_filetype_add', {
      path: '/add-new',
      component: DashboardAddFileType,
      auth: true,
      permissionName: 'file-type',
      requiredManageAccess: true,
    });
    Route.group('/:filetypeId', () => {
      Route.add('dashboard_filetype_edit', {
        path: '/edit',
        component: DashboardEditFileType,
        auth: true,
        permissionName: 'file-type',
        requiredManageAccess: true,
      });
    });
  });

  Route.group('/forms', () => {
    Route.add('dashboard_forms_all', {
      path: '/all',
      component: DashboardForms,
      auth: true,
      permissionName: 'form-settings',
    });
    Route.group('/:formId', () => {
      Route.add('dashboard_form_settings', {
        path: '/settings',
        component: DashboardFormSettings,
        auth: true,
        permissionName: 'form-settings',
        requiredManageAccess: true,
      });
    });
    Route.group('/:formName', () => {
      Route.add('dashboard_form_files_archive', {
        path: '/:itemId',
        component: DashboardFormFilesArchive,
        auth: true,
      });
    });
  });
});

Route.group('/driver', () => {
  Route.group('/inspections', () => {
    Route.add('driver_inspections_all', {
      path: '/all',
      component: DriverInspections,
      auth: true,
      permissionName: 'vehicle-inspection-driver',
    });
    Route.add('driver_inspection_add', {
      path: '/add-new',
      // component: DriverAddInspection,
      component: DriverInspections,
      auth: true,
      permissionName: 'vehicle-inspection-driver',
      requiredManageAccess: true,
    });
    // Route.group("/:inspectionId", () => {
    //     Route.add("driver_inspection_edit", {
    //         path: "/edit",
    //         component: DriverEditInspection,
    //         auth: true,
    //         permissionName: 'vehicle-inspection-driver',
    //         requiredManageAccess: true
    //     });
    //     Route.add("driver_inspection", {
    //         path: "/inspection",
    //         component: DriverInspection,
    //         auth: true,
    //         permissionName: 'vehicle-inspection-driver',
    //     });
    // });
  });
});

Route.homePage(Login);
Route.error404(NotFound);

export default Route;
